<app-assign-distributor-staff [distributorDataInput]="distributorData"></app-assign-distributor-staff>
<app-list-distributor-staff [distributorDataInput]="distributorData"></app-list-distributor-staff>
